// @ts-ignore
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'

export const exportJsPdf = async (fileName: string, ref: any, callback?: () => void) => {
    try {
        if (!ref?.current) {
            console.error('Ref non valido')
            callback && callback()
            return
        }

        // Forza windowWidth a 1200px per avere layout Bootstrap MD/LG
        const canvas = await html2canvas(ref.current, {
            scale: 3,
            useCORS: true,
            logging: false,
            windowWidth: 1200,
            onclone: (clonedDoc: Document) => {
                // Stili print-only/no-print
                const printElements = clonedDoc.querySelectorAll('.print-only')
                printElements.forEach((el: any) => {
                    el.style.display = 'block'
                    el.style.visibility = 'visible'
                })

                const noPrintElements = clonedDoc.querySelectorAll('.no-print')
                noPrintElements.forEach((el: any) => {
                    el.style.display = 'none'
                })

                const sizePrint = clonedDoc.querySelectorAll("[data-print-size]")
                sizePrint.forEach((el: any) => {
                    el.style.width = el.getAttribute("data-print-size")
                })
            }
        })

        // Usa A4 reale, non A2
        const pdf = new jsPDF({
            orientation: 'portrait',
            unit: 'mm',
            format: 'a4',
        })

        const pdfWidthMm  = pdf.internal.pageSize.getWidth()  // 210mm
        const pdfHeightMm = pdf.internal.pageSize.getHeight() // 297mm

        // Margini 10mm come exportPdf
        const marginMm = 10
        const usableWidthMm  = pdfWidthMm  - marginMm * 2  // 190mm
        const usableHeightMm = pdfHeightMm - marginMm * 2  // 277mm

        // Scala per far stare il canvas nella larghezza A4 disponibile
        const mmPerCanvasPx = usableWidthMm / canvas.width

        // Altezza in px di una striscia che entra in una pagina
        const sliceHeightPx = Math.floor(usableHeightMm / mmPerCanvasPx)

        let yPx = 0
        let first = true

        while (yPx < canvas.height) {
            const pageCanvas = document.createElement('canvas')
            pageCanvas.width  = canvas.width
            pageCanvas.height = Math.min(sliceHeightPx, canvas.height - yPx)

            const ctx = pageCanvas.getContext('2d')!
            ctx.drawImage(
                canvas,
                0, yPx, pageCanvas.width, pageCanvas.height, // src
                0, 0, pageCanvas.width, pageCanvas.height    // dst
            )

            const pageImg = pageCanvas.toDataURL('image/jpeg', 0.98)

            const imgWidthMm  = usableWidthMm          // 100% larghezza
            const imgHeightMm = pageCanvas.height * mmPerCanvasPx

            if (!first) pdf.addPage()
            pdf.addImage(pageImg, 'JPEG', marginMm, marginMm, imgWidthMm, imgHeightMm)

            yPx += sliceHeightPx
            first = false
        }

        pdf.save(`${fileName}.pdf`)
        callback && callback()
    } catch (error) {
        console.error('Errore nella generazione del PDF:', error)
        callback && callback()
    }
}
